import { render, staticRenderFns } from "./create.vue?vue&type=template&id=ddd58146&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports